import { TagProps } from '@servicetitan/design-system';
import { TenantStatus } from '@servicetitan/marketing-tenant-management-api';

export const tenantStatusProps: Record<
    TenantStatus,
    {
        displayName: string;
        color: TagProps['color'];
        icon?: TagProps['icon'];
    }
> = {
    [TenantStatus.NONE]: {
        displayName: 'None',
        color: 'critical',
    },
    [TenantStatus.NEW]: {
        displayName: 'New',
        color: 'info',
    },
    [TenantStatus.ONBOARDING]: {
        displayName: 'Onboarding',
        color: 'default',
    },
    [TenantStatus.ACTIVE]: {
        displayName: 'Active',
        color: 'success',
    },
    [TenantStatus.SUSPENDED]: {
        displayName: 'Suspended',
        color: 'critical',
    },
    [TenantStatus.DELETED]: {
        displayName: 'Deleted',
        color: 'default',
        icon: 'not_interested',
    },
};
